import { render, staticRenderFns } from "./Zimu2.vue?vue&type=template&id=58d5d250&"
import script from "./Zimu2.vue?vue&type=script&lang=js&"
export * from "./Zimu2.vue?vue&type=script&lang=js&"
import style0 from "./Zimu2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports